import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { INDIAN_STATES } from 'src/app/private/constants/indian-states';
import { ManageBusinessInfoService } from 'src/app/private/services/manage-business-info.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-manage-bussiness-info',
  templateUrl: './manage-bussiness-info.component.html',
  styleUrls: ['./manage-bussiness-info.component.scss']
})
export class ManageBussinessInfoComponent implements OnInit {

  client: Client = new Client();
  isLoading = false;
  btnLoading = false;
  isImageUploading = false;
  isDragging = false;
  uploadProgress = 0;

  indianStates = INDIAN_STATES;

  onBillingStateChange(stateName: string): void {
    const match = this.indianStates.find(s => s.name === stateName);
    if (match) {
      this.client.gst_state_code = match.code;
    }
  }

  constructor(
    private api: ManageBusinessInfoService,
    private toast: ToastrService,
    private localStorage: LocalStorageService,
    private uploadService: UploadService
  ) { }

  ngOnInit(): void {
    this.getClientInfo();
  }

  getClientInfo() {
    this.isLoading = true;
    const param = {
      client_id: this.localStorage.getClientId()
    };
    
    this.api.getClient(param).subscribe({
      next: (res: any) => {
        if (res && res.data) {
           this.client = { ...this.client, ...res.data };
        } else if (res) {
           this.client = { ...this.client, ...res };
        }
        
        // Ensure bool is handled if it comes as string "true"/"false" from API
        if (typeof this.client.is_gst_registered === 'string') {
            this.client.is_gst_registered = (this.client.is_gst_registered === 'true');
        }

        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.error(err);
      }
    });
  }

  save() {
    this.btnLoading = true;
    
    if (!this.client.name) {
        this.toast.error("Business Name is required");
        this.btnLoading = false;
        return;
    }
    
    // Ensure client_id is set if it was empty
    if (!this.client.client_id) {
        this.client.client_id = this.localStorage.getClientId();
    }

    this.api.updateClient(this.client).subscribe({
      next: (res) => {
        this.toast.success('Business Info Updated Successfully');
        this.btnLoading = false;
      },
      error: (err) => {
        this.toast.error(err.error?.msg || 'Failed to update Business Info');
        this.btnLoading = false;
      }
    });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      this.uploadFile(event.dataTransfer.files[0]);
    }
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.uploadFile(event.target.files[0]);
    }
  }

  uploadFile(file: File) {
    // Validate file type
    if (!file.type.startsWith('image/')) {
        this.toast.error('Please upload an image file');
        return;
    }

    this.isImageUploading = true;
    this.uploadProgress = 0;
    
    const formData = new FormData();
    formData.append('file', file);
    const folder = `public/client-${this.localStorage.getClientId()}/logo`;
    formData.append('folders', folder);
    formData.append('bucket', 'emruploads');

    this.uploadService.uploadDocumentsWithProgress(formData).subscribe({
      next: (event: any) => {
        if (event.type === 'progress') {
            this.uploadProgress = event.progress;
        } else if (event.type === 'response') {
            this.isImageUploading = false;
            const res = event.body;
            let url = '';
            if (res && res.url) {
                url = res.url;
            } else if (res && res.data && res.data.url) {
                url = res.data.url;
            }

            if (url) {
                this.client.logo = url;
                this.toast.success('Logo uploaded successfully');
            } else {
                this.toast.error('Upload failed: No URL returned');
            }
        }
      },
      error: (err) => {
        this.isImageUploading = false;
        this.uploadProgress = 0;
        this.toast.error('Failed to upload logo');
        console.error(err);
      }
    });
  }
}

export class Client {
  client_id?: any;
  name: string = "";
  description: string = "";
  logo: string = "";
  license_no: string = "";
  email: string = "";
  contact: string = "";
  specialty: string = "";
  district_id: any;
  dateFormat: string = "DD-MM-YYYY";
  other_settings: any = {};
  state_id: any;
  city_id: any;
  country_id: any;
  address: string = "";
  gstin: string = "";
  gst_state_code: string = "";
  is_gst_registered: boolean = false;
  billing_name: string = "";
  billing_email: string = "";
  billing_phone: string = "";
  billing_address_line1: string = "";
  billing_address_line2: string = "";
  billing_city: string = "";
  billing_state: string = "";
  billing_pincode: string = "";
  billing_country: string = "";
}
